import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Form as FormikForm } from 'formik';
import * as Yup from 'yup';
import { updateOrganizerAsAdmin } from '../../api/Admin';
import OrganizerInformationSection from './createOrganizerForm/OrganizerInformationSection';
import { useState } from 'react';
import Spinner from 'react-bootstrap/esm/Spinner';

function UpdateOrganizerModal(props) {
  const {
    organizer,
    setToastType,
    setToastTitle,
    setToastBody,
    setShowToast,
    ...rest
  } = props;
  const [updating, setUpdating] = useState(false);

  const organizerSchema = Yup.object().shape({
    name: Yup.string().required('Du måste ange ett klubbnamn'),
    district: Yup.string()
      .required('Du måste välja ett distrikt')
      .oneOf(
        [
          'Gotlands BF',
          'Göteborgs BF',
          'Mellan Norrlands BF',
          'Nedre Norra BF',
          'Smålands BF',
          'Stockholms BF',
          'Söder-/ Västmanlands BF',
          'Södra BF',
          'Upplands BF',
          'Västra BF',
          'Östergötland BF',
          'Övre Norra BF',
        ],
        'Du måste välja ett distrikt'
      ),
    organizationNumber: Yup.string()
      .matches(/^[0-9\-]+$/, 'Endast siffror och bindestreck tillåtet')
      .min(10, 'För kort organisationsnummer')
      .max(11, 'För långt organisationsnummer')
      .required('Du måste ange ett organisationsnummer'),

    swishNumber: Yup.string()
      .matches(/^[0-9]+$/, 'Endast siffror tillåtet')
      .min(10, 'För kort Swish-nummer')
      .max(10, 'För långt Swish-nummer')
      .test(
        'check-company-number',
        'Swish-numret måste vara ett företagsnummer',
        function (value) {
          if (!value || value.toString().substring(0, 3) === '123') {
            return true;
          }
          return false;
        }
      ),
  });

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby="contained-modal-title-vcenter"
      className="p-3"
    >
      <Modal.Header closeButton>
        <Modal.Title>Redigera {organizer?.clubName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Redigera arrangörskontot</p>

        <Formik
          initialValues={{
            name: organizer?.clubName,
            district: organizer?.district,
            organizationNumber: organizer?.organizationNumber,
            swishNumber: organizer?.swishNumber,
          }}
          onSubmit={async (values) => {
            setUpdating(true);
            const result = await updateOrganizerAsAdmin(organizer.id, values);
            if (result) {
              switch (result.statusCode) {
                case 200:
                  setToastType('success');
                  setToastTitle('Arrangör uppdaterad');
                  setToastBody('Arrangören har blivit uppdaterad');
                  break;
                default:
                  setToastType('danger');
                  setToastTitle('Arrangör ej uppdaterad');
                  setToastBody('Arrangören kunde inte uppdateras');
                  break;
              }
              props.onHide();
              setShowToast(true);
              setUpdating(false);
            }
          }}
          validationSchema={organizerSchema}
          enableReinitialize={true}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <FormikForm
              id="form-update-organizer"
              noValidate
              onSubmit={handleSubmit}
            >
              <OrganizerInformationSection
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
                edit={true}
              />
            </FormikForm>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button onClick={() => props.onHide()} variant="outline-secondary">
          Avbryt
        </Button>
        <Button type="submit" form="form-update-organizer">
          {updating ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              <span className="visually-hidden">Loading...</span>
              Spara
            </>
          ) : (
            'Spara'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UpdateOrganizerModal;
